import { useLocation, useNavigate } from 'react-router-dom';
import BreadCrumb from '../../components/breadCrumb/BreadCrumb';
import NavBarWithoutLogo from '../../components/header/navaBarWithoutLogo';
import RadioButtonOptions from '../../components/radioButton/radioButtonOptions';
import { useEffect, useState } from 'react';
import { useSendOtp } from '../../common/services/otp/apiDanaConnect';
import { useAuth } from '../../common/provider/authContextType';
import Loading from '../../components/elements/loading';

interface OtpGetPageProps {
  option: string;
}

const OtpGetPage: React.FC<OtpGetPageProps> = ({ option }) => {
  const [verificationMethod, setMerificationMethod] = useState(0);
  const [messageError, setMessageError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [historyIndex, setHistoryIndex] = useState<number>(
    window.history.state?.idx || 0
  );
  const { expirationTime } = useAuth();
  const payload = location.state?.payload;
  const phoneNumber = payload?.phoneNumber || '';
  const error =
    '¡Estamos teniendo problemas técnicos! Por favor, intenta de nuevo.';
  const timeRemaining = expirationTime; // 180 seconds

  const {
    mutate,
    data: dataSentOtp,
    isSuccess: isSuccessSentOtp,
    isError,
    isPending: isPendingSentOtp,
  } = useSendOtp();

  useEffect(() => {
    localStorage.removeItem('otpExpirationTime');
  }, []);

  useEffect(() => {
    if (payload) {
      payload.verificationMethod = verificationMethod;
    }
  }, [verificationMethod]);

  useEffect(() => {
    if (isSuccessSentOtp) {
      if (dataSentOtp?.responseCode === '01') {
        payload.idRequest = dataSentOtp.idRequest;
        const expirationTime = Date.now() + timeRemaining * 1000; // 120000 ms = 120 segundos
        localStorage.setItem('otpExpirationTime', expirationTime.toString());
        navigate(
          option === 'forgotPassword'
            ? '/olvide-contrasena/paso-2-validacion-de-codigo'
            : '/quiero-registrarme/paso-2-validacion-de-codigo',
          { state: { payload } }
        );
      } else {
        setMessageError(error);
      }
    }
  }, [isSuccessSentOtp]);

  useEffect(() => {
    if (isError) {
      setMessageError(error);
    }
  }, [isError]);

  useEffect(() => {
    const handlePopState = () => {
      const currentIndex = window.history.state?.idx || 0;

      if (currentIndex < historyIndex) {
        console.log('Retrocediendo en el historial');
        // Lógica para retroceder
      } else if (currentIndex > historyIndex) {
        console.log('Avanzando en el historial');
        // Lógica para avanzar
        window.history.back();
      }

      setHistoryIndex(currentIndex); // Actualiza el índice del historial
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleVerificationMethod = (method: number) => {
    setMerificationMethod(method);
  };

  const handleClick = () => {
    mutate({
      data: {
        email: payload?.email,
        phoneNumber: payload?.phoneNumber,
        verificationMethod: verificationMethod.toString(),
        names: payload?.names,
        identityDocument: payload?.identityDocument,
        identityDocumentTypeId: payload?.identityDocumentTypeId,
      },
    });
  };

  return (
    <>
      <div
        data-animation="default"
        data-collapse="medium"
        data-duration="400"
        data-easing="ease"
        data-easing2="ease"
        className="menu is-blanco w-nav">
        <NavBarWithoutLogo />
      </div>
      {isPendingSentOtp && <Loading />}
      <section className="info-h">
        <div className="padding-global">
          <div className="padding-section-medium">
            <div className="container-medium">
              <div className="info_wrp">
                <div className="infor_form w-form">
                  <form
                    id="email-form-2"
                    name="email-form-2"
                    data-name="Email Form 2"
                    method="get"
                    className="form-paso-1"
                    data-wf-page-id="67226c83a99f39abdac5996c"
                    data-wf-element-id="a6ccd524-0406-410e-b27b-7cb6ad3096ca">
                    <BreadCrumb currentStep={1} />
                    <div className="title-component is-center">
                      <h2>
                        Elige cómo prefieres recibir el <br />
                        código de verificación
                      </h2>
                    </div>
                    <RadioButtonOptions
                      email={payload.email}
                      telephone={phoneNumber}
                      handleVerificationMethod={handleVerificationMethod}
                    />
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>
                      Oops! Something went wrong while submitting the form.
                    </div>
                  </div>
                </div>
                <div className="text-weight-bold text-align-center">
                  Recuerda que lo enviaremos al mail o celular que <br />
                  tengas registrado con nosotros
                </div>
                <div className="box_text">
                  <div>
                    Si no reconoces tus datos de contacto, por favor, comunícate
                    con nosotros al 01 219 1919. Si necesitas actualizar tus
                    datos de contacto, te invitamos a utilizar nuestro
                    formulario de actualización de datos.
                  </div>
                </div>
                {(isError || isSuccessSentOtp) && (
                  <div className="text-error">{messageError}</div>
                )}
                <button
                  onClick={handleClick}
                  className="button is-extralarge w-button">
                  Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OtpGetPage;
